import { useCallback, useEffect, useState } from "react";
import { WPPagesFilter } from "../interface";
import { AxiosResponse } from "axios";
import { Page } from "@base/types/wp";
import wpPagesService from "../wpPagesService";

const useGetPages = (filter: WPPagesFilter, enabled = true) => {
  const [data, setData] = useState<AxiosResponse<Page[]>>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return wpPagesService.getPages(filter);
  }, [filter]);

  const transformResponse = useCallback(
    (response: AxiosResponse<Page[]>) => {
      if (response) {
        setData(response);
      }
    },
    [filter],
  );

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data, error, isLoading, refetch };
};

export default useGetPages;
